window.Sparkle ??= {};

window.Sparkle.ResourceStorage = class ResourceStorage {
  static STORAGE_KEY = "resource-storage";

  constructor(resourceType, resourceId) {
    this.set = this.set.bind(this);
    this.get = this.get.bind(this);
    this.persist = this.persist.bind(this);
    this.storage = JSON.parse(window.localStorage.getItem(this.constructor.STORAGE_KEY) || "{}");
    this.resourceKey = `${resourceType}${resourceId}`;
    this.resourceStorage = this.storage[this.resourceKey] = this.storage[this.resourceKey] || {};
  }

  set(key, value, autoPersist = true) {
    if (value) {
      this.resourceStorage[key] = value;
    } else {
      delete this.resourceStorage[key];
    }

    if (autoPersist) {
      this.persist();
    }
    return value;
  }

  get(key) {
    return this.resourceStorage[key];
  }

  persist() {
    return window.localStorage.setItem(this.constructor.STORAGE_KEY, JSON.stringify(this.storage));
  }
};
